import React from 'react'

const Nomenclatures = props => (
    <svg {...props}>
        <path d="M12 53c3.86 0 7-3.141 7-7 0-3.519-2.613-6.432-6-6.92V8a1 1 0 10-2 0v31.08c-3.387.488-6 3.401-6 6.92 0 3.859 3.14 7 7 7zm0-12c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5zM47 20.92V52a1 1 0 102 0V20.92c3.387-.488 6-3.401 6-6.92 0-3.859-3.14-7-7-7s-7 3.141-7 7c0 3.519 2.613 6.432 6 6.92zM48 9c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5zM29 35.92V52a1 1 0 102 0V35.92c3.387-.488 6-3.401 6-6.92s-2.613-6.432-6-6.92V8a1 1 0 10-2 0v14.08c-3.387.488-6 3.401-6 6.92s2.613 6.432 6 6.92zM30 24c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5z"></path>
        <path d="M59 0H1a1 1 0 00-1 1v58a1 1 0 001 1h58a1 1 0 001-1V1a1 1 0 00-1-1zm-1 58H2V2h56v56z"></path>
    </svg>
)

export default Nomenclatures
